import React from 'react';
import { Alert, Box, Button, Container, Typography } from '@mui/material';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('La interfaz se recuperó de un error de renderizado:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <Container maxWidth="sm" className="notranslate" translate="no">
        <Box sx={{ py: 8 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Una extensión del navegador modificó la página mientras se actualizaba.
          </Alert>
          <Typography sx={{ mb: 2 }}>
            La operación realizada puede haber terminado correctamente. Recarga la interfaz para continuar.
          </Typography>
          <Button variant="contained" onClick={this.handleReload}>
            Recargar interfaz
          </Button>
        </Box>
      </Container>
    );
  }
}

export default AppErrorBoundary;
